$(function() {
  //教習予約カレンダーに列毎のclassを付与
  //一番目の科目だけ初期表示するために、activeclassを付与
  $("th:nth-child(2), td:nth-child(2)").addClass("subject-1 active");
  $("th:nth-child(3), td:nth-child(3)").addClass("subject-2");
  $("th:nth-child(4), td:nth-child(4)").addClass("subject-3");
  $("th:nth-child(5), td:nth-child(5)").addClass("subject-4");
  $("th:nth-child(6), td:nth-child(6)").addClass("subject-5");
  $("th:nth-child(7), td:nth-child(7)").addClass("subject-6");
  $("th:nth-child(8), td:nth-child(8)").addClass("subject-7");
  $("th:nth-child(9), td:nth-child(9)").addClass("subject-8");
  $("th:nth-child(10), td:nth-child(10)").addClass("subject-9");

  //セッションストレージが使用できるブラウザのみで発動
  if (typeof sessionStorage !== 'undefined') {
    //セッションストレージに値が入っている場合
    if(sessionStorage.string!=null){
      //予約テーブルからactive classを削除
      $('td,th').removeClass('active');
      //前ページなどで選択されていたセレクトボックスの科目を選択する
      $("#select_subject").val(sessionStorage.string);
      //前ページなどで選択されていた科目のテーブルをそのまま表示させる処理
      if (sessionStorage.string === 'awp') {
        $('td.subject-1, th.subject-1').addClass('active');
      }else if (sessionStorage.string === 'forklift') {
        $('td.subject-2, th.subject-2').addClass('active');
      }else if (sessionStorage.string === 'smc') {
        $('td.subject-3, th.subject-3').addClass('active');
      }else if (sessionStorage.string === 'foc') {
        $('td.subject-4, th.subject-4').addClass('active');
      }else if (sessionStorage.string === 'slinging') {
        $('td.subject-5, th.subject-5').addClass('active');
      }else if (sessionStorage.string === 'vcm') {
        $('td.subject-6, th.subject-6').addClass('active');
      }else if (sessionStorage.string === 'sv') {
        $('td.subject-7, th.subject-7').addClass('active');
      }else if (sessionStorage.string === 'gw') {
        $('td.subject-8, th.subject-8').addClass('active');
      }else if (sessionStorage.string === 'fullharness') {
        $('td.subject-9, th.subject-9').addClass('active');
      }
    }
  } else {
    window.alert("本ブラウザではWeb Storageが使えません");
  }
    //セレクトボックスが切り替わったら発動
    $('select').change(function() {
      var subject_name = $(this).val();
      //テーブルからactive classを取り除く
      $('td, th').removeClass('active');
      //セレクトボックスが切り替わったら、テーブルが変化するので、そのことがわかるように、ページトップへスクロール
      $('html,body').animate({scrollTop:0},1000);
      //セレクトボックスで選択された科目のセルにactive classを付与することで、テーブルを切り替える
      if (subject_name === 'awp') {
        $('td.subject-1, th.subject-1').addClass('active');
      }else if (subject_name === 'forklift') {
        $('td.subject-2, th.subject-2').addClass('active');
      }else if (subject_name === 'smc') {
        $('td.subject-3, th.subject-3').addClass('active');
      }else if (subject_name === 'foc') {
        $('td.subject-4, th.subject-4').addClass('active');
      }else if (subject_name === 'slinging') {
        $('td.subject-5, th.subject-5').addClass('active');
      }else if (subject_name === 'vcm') {
        $('td.subject-6, th.subject-6').addClass('active');
      }else if (subject_name === 'sv') {
        $('td.subject-7, th.subject-7').addClass('active');
      }else if (subject_name === 'gw') {
        $('td.subject-8, th.subject-8').addClass('active');
      }else if (subject_name === 'fullharness') {
        $('td.subject-9, th.subject-9').addClass('active');
      }
      //セッションストレージが使用できるブラウザのみで発動
      if (typeof sessionStorage !== 'undefined') {
        //選択された科目をセッションストレージに保存
        sessionStorage.string = subject_name;
      } else {
        window.alert("本ブラウザではWeb Storageが使えません");
      }
    });

});
